<div class="errorMessage" *ngIf="formError">
  <div [innerHTML]="formErrorMessage"></div>
  <div *ngFor="let item of formFieldsErrors">
    {{ item }}
  </div>
</div>
